export default "/_next/static/chunks/fonts/Source Sans Pro LightIt-270ee59ba0b29ee4c4934c3b6b1ba569.otf";